module.exports = __webpack_public_path__ + "main/images/shared/listen-articles@3x.1bc6a31dd5356ffb4091218bd1b2d26b.png";